//core
import React from 'react';
import {useTranslation} from "react-i18next";
import arePropsEqual from "react-fast-compare";
import {Chip} from "@mui/material";

//theme
import {Theme} from "@mui/material/styles/createTheme";
import {useTheme} from "@mui/styles";
import {
  red,
  green,
  lightGreen,
  blueGrey,
  amber,
} from "@mui/material/colors";


interface IStatus {
  value: string;
}

const WithdrawalStatus = ({value}: IStatus) => {
  const theme: Theme = useTheme();
  const {t} = useTranslation();

  return (
    <>
      {value === "pending" && <Chip size="small" label={t("common.components.status.pending")} color="primary" sx={{backgroundColor: amber[500]}}/>}
      {value === "approved" && <Chip size="small" label={t("common.components.status.approved")} color="primary" sx={{backgroundColor: lightGreen[500]}}/>}
      {value === "declined" && <Chip size="small" label={t("common.components.status.declined")} color="primary" sx={{backgroundColor: blueGrey[500]}}/>}
      {value === "canceled" && <Chip size="small" label={t("common.components.status.canceled")} color="primary" sx={{backgroundColor: blueGrey[500]}}/>}
      {value === "failed" && <Chip size="small" label={t("common.components.status.failed")} color="primary" sx={{backgroundColor: red[500]}}/>}
    </>
  );
};

export default React.memo(WithdrawalStatus, arePropsEqual)
